import type { GetKycResponse } from "@/api/queries";

export type ProcessKycStatusesResponse = {
  showKyc: boolean;
  showKycPending: boolean;
};

export function processKycStatuses(kyc: Partial<GetKycResponse> | null): ProcessKycStatusesResponse {
  const showKyc = !!(kyc?.kycrequired && !kyc?.kycpassed && kyc?.messages && kyc.messages.length > 0 && kyc.messages[0] === "KYC Required");
  const showKycPending = !!(kyc?.kycrequired && !kyc?.kycpassed && kyc?.messages && kyc.messages.length > 0 && kyc.messages[0] === "KYC still pending");
  return { showKyc, showKycPending };
}
